'use strict';

const EXPORT_DURATION_DAYS = 7;
const EXPORT_LIMIT = 10;

const EXPORT_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  SUCCESS: 'success',
  FAILURE: 'failure',
  CLICKED: 'clicked',
};

const EXPORT_TYPE = {
  EMAIL_RENTAL: 9,
};

export {
  EXPORT_DURATION_DAYS,
  EXPORT_LIMIT,
  EXPORT_STATUS,
  EXPORT_TYPE,
};
